const TOKEN_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
export const generateToken = n => [...Array(n)].map(() => TOKEN_CHARS[Math.floor(Math.random() * TOKEN_CHARS.length)]).join('');
export const getPopupFeatures = () => {
  const popupWidth = 600;
  const popupHeight = 600;
  const popupTop = window.screenY + (window.outerHeight - popupHeight) / 2;
  const popupLeft = window.screenX + (window.outerWidth - popupWidth) / 2;
  return `height=${popupHeight},width=${popupWidth},top=${popupTop},left=${popupLeft}`;
};
//# sourceMappingURL=utils.js.map